import React from "react";
import pcgcLogo from "../../assets/images/PCGC_Login_logo.png";
import appStore from "../../assets/images/appstore.png";
import playStore from "../../assets/images/playstore.png";

const Blocked = () => {
    
    return (
        <div
             style={{
                minHeight: "70vh",
                width: "100%",
                backgroundColor: "rgb(250 250 250)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                padding: "20px"
            }}
        >
            <div>
                <img
                    src={pcgcLogo}
                    alt="PCGC Logo"
                    style={{
                        width: "120px",
                        maxWidth: "100%",
                        // marginBottom: "25px"
                    }}
                />

                <h1
                    style={{
                        fontSize: "30px",
                        color: "#1f3554",
                        fontWeight: "400",
                        marginBottom: "40px"
                    }}
                >
                    The Poona Golf Club
                </h1>

                <h2
                    style={{
                        color: "#e53935",
                        fontSize: "30px",
                        fontWeight: "400",
                        marginBottom: "1px"
                    }}
                >
                    PCGC Web based Tee Time Booking is disabled.
                </h2>

                <p
                    style={{
                        color: "#e53935",
                        fontSize: "20px",
                        marginBottom: "10px"
                    }}
                >
                    Kindly Download PCGC Golf App.
                </p>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "20px",
                        flexWrap: "wrap"
                    }}
                >
                    <a
                        href="https://apps.apple.com/in/app/the-poona-club-ltd-golf/id1487942236"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            src={appStore}
                            alt="Download on App Store"
                            style={{ width: "110px",  }}
                        />
                    </a>

                    <a
                        href="https://play.google.com/store/apps/details?id=in.golfez.pcgc"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            src={playStore}
                            alt="Get it on Google Play"
                            style={{ width: "100px", paddingTop:"2px" }}
                        />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Blocked;